import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide-v20';

import { defaultFontSizeCSS } from '@styles/generalStyles';

export const StyledDiscountMessage = styled.div<{ isDisabled: boolean }>`
  color: ${({ isDisabled }) => (isDisabled ? theme.color.text.disabled : theme.color.text.primary)};
  ${defaultFontSizeCSS};

  @media (min-width: ${breakpoints.sm}) {
    line-height: 1.625rem;
  }
`;

export const StyledDisabledMessage = styled.div`
  color: ${theme.color.text.disabled};
  ${defaultFontSizeCSS}
`;
